export default __webpack_public_path__ + "static/media/1c.26264608.jpg";